<template>
  <div class="eb-breadcrumb">
    <el-breadcrumb separator=">">
      <!-- <el-breadcrumb-item  v-if="breakCrumbData.breakCrumbArr" v-for="item in breakCrumbData.breakCrumbArr" :key="item.link" :to="{ path: item.link }">{{item.text}}</el-breadcrumb-item> -->
      <el-breadcrumb-item v-show="breakCrumbData.breakCrumbArr" v-for="item in breakCrumbData.breakCrumbArr" :key="item.link">
        <a :href="item.link">{{item.text}}</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="breakCrumbData.lastBreakCrumb&&!lastText">{{breakCrumbData.lastBreakCrumb.text}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!(breakCrumbData.lastBreakCrumb&&!lastText)">{{lastText}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import BreakCrumb from '@/plugins/break-crumb';
export default {
  name: 'ebBreakCrumb',
  props: {
    lastText: {}
  },
  data() {
    return {
      breakCrumbData: {
        breakCrumbArr: null,
        lastBreakCrumb: null
      }
    };
  },
  mounted() {
    setTimeout(() => {
      var breakCrumb = new BreakCrumb();
      this.setBreakCrumb(breakCrumb);
      this.breakCrumbData = breakCrumb.getBreakCrumb();
    });
  },
  methods: {
    setBreakCrumb: function(breakCrumb) {
      var pathname = location.pathname;
      var arr = breakCrumb.getBreakCrumb();
      if (arr.lastBreakCrumb.link === pathname) {
        return;
      }
      if (pathname.indexOf('/v2/rule/template/preview') !== -1) {
        breakCrumb.setBreakCrumb('规则预览');
      }

      if (pathname.indexOf('/projbid/preview') !== -1) {
        breakCrumb.setBreakCrumb('需求详情');
      }
      if (pathname.indexOf('/projbid/quotation/summary/') !== -1) {
        breakCrumb.setBreakCrumb('报价汇总');
      }
      if (pathname.indexOf('/projbid/quotation/detail/') !== -1) {
        breakCrumb.setBreakCrumb('报价详情');
      }
      if (pathname.indexOf('/projbid/demand/') !== -1) {
        breakCrumb.setBreakCrumb('需求详情');
      }
      if (pathname.indexOf('/projbid/reply/detail') !== -1) {
        breakCrumb.setBreakCrumb('报价详情');
      }

      if (pathname.indexOf('/projpro/preview') !== -1) {
        breakCrumb.setBreakCrumb('需求详情');
      }
      if (pathname.indexOf('/projpro/quotation/summary/') !== -1) {
        breakCrumb.setBreakCrumb('报价汇总');
      }
      if (pathname.indexOf('/projpro/quotation/detail/') !== -1) {
        breakCrumb.setBreakCrumb('报价详情');
      }
      if (pathname.indexOf('/projpro/demand/') !== -1) {
        breakCrumb.setBreakCrumb('需求详情');
      }
      if (pathname.indexOf('/projpro/reply/detail') !== -1) {
        breakCrumb.setBreakCrumb('报价详情');
      }
      if (pathname.indexOf('/user/edit/') !== -1) {
        breakCrumb.setBreakCrumb('修改用户信息');
      }
      if (pathname.indexOf('/notarization/verification/edit') !== -1) {
        breakCrumb.setBreakCrumb('鉴证报告申请');
      }
      if (pathname.indexOf('/payment/applyInvoice') !== -1) {
        breakCrumb.setBreakCrumb('发票申请');
      }
      if (pathname.indexOf('/invoice/detail/') !== -1) {
        breakCrumb.setBreakCrumb('发票详情');
      }
      if (pathname.indexOf('/notarization/detail/') !== -1) {
        breakCrumb.setBreakCrumb('鉴证报告详情');
      }
      if (pathname.indexOf('/org/detail/') !== -1) {
        breakCrumb.setBreakCrumb('机构详情');
      }
      if (pathname.indexOf('/projpro/demand/') !== -1) {
        breakCrumb.setBreakCrumb('询价项目详情');
      }
      if (pathname.indexOf('/projbid/demand/') !== -1) {
        breakCrumb.setBreakCrumb('招标项目详情');
      }
      if (pathname.indexOf('/supplier/detail') !== -1) {
        breakCrumb.setBreakCrumb('机构详情');
      }
    }
  }
};
</script>
<style scoped lang="less">
</style>
